export enum FollowingStatusType {
  PENDING = "pending",
  FOLLOWING = "following",
  NOT_FOLLOWING = "notFollowing",
  NOT_ALLOWED = "notAllowed",
}
